import React from 'react';

export default function Mask({ height = '100%', color = '0,0,0', opacity = 0.5 }) {
  return (
    <div
      className="mask"
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height,
        zIndex: 1,
        backgroundColor: `rgba(${color},${opacity})`
      }}
    />
  );
}
